<template>
<div class="hp-reports">
    <z-caption
        class="u-bottom-margin--xl"
        size="xl"
        :href="`/${$root.lang}/investors/reports-and-results/`"
        uppercase
    >
        <span v-html="text.title"></span>
    </z-caption>
    <slider v-show="device !== 'mobile'" :space-between="32">
        <slide
            v-for="(slide, slideIndex) in desktopSlides"
            :key="slideIndex"
        >
            <div class="hp-reports-slide">
                <div class="row hp-reports-slide__row">
                    <div
                        class="col-default-6 col-mobile-12"
                        v-for="(card, cardIndex) in slide"
                        :key="cardIndex"
                    >
                        <z-report-block
                            :class="[
                                'hp-reports-slide__card',
                                { 'hp-reports-slide__card--mt': cardIndex % 2 !== 0 }
                            ]"
                            :image="card.image"
                            :link="card.link"
                            :title="card.title"
                            interactive="hover"
                            :title-period="card.titlePeriod"
                        />
                    </div>
                </div>
            </div>
        </slide>
    </slider>
    <slider v-show="device === 'mobile'" :space-between="32">
        <slide
            v-for="(item, index) in data"
            :key="index"
        >
            <div class="hp-reports-slide">
                <div class="row hp-reports-slide__row">
                    <div class="col-default-6 col-mobile-12">
                        <z-report-block
                            class="hp-reports-slide__card"
                            :image="item.image"
                            :link="item.link"
                            :title="item.title"
                            :title-period="item.titlePeriod"
                        />
                    </div>
                </div>
            </div>
        </slide>
    </slider>
</div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin'
import { localize } from '@/utils/i18n'

export default {
    name: 'reports',
    mixins: [mixinDevice],
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                title: localize({
                    ru: 'Отчеты и результаты',
                    en: 'Reports and Results'
                })
            }
        }
    },
    computed: {
        desktopSlides () {
            let result = []
            this.data.forEach((item, i) => {
                let key = (i % 2 === 0 ? i : (i - 1)) / 2
                if (!result[key]) result[key] = []
                result[key].push(item)
            })

            return result
        }
    }
}
</script>

<style lang="scss">
.hp-reports {
    @include breakpoint (tablet) {
        @include margin-level (top, L);
    }
}

.hp-reports-slide {
    &__row {
        justify-content: space-between;
    }

    &__card {
        @include breakpoint (v-tablet) {
            width: 100%;
            max-width: none !important;
        }

        &--mt {
            @include margin-level(top, 2XL);
            margin-left: auto;

            @include breakpoint (tablet) {
                margin-left: 0;
            }

            @include breakpoint (mobile) {
                margin-top: 0;
            }
        }
    }

   /* .z-report-block__image {
        border: none
    }*/
}
</style>
